import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';

export default class SettingsDepartmentsBaseController extends Controller {
  @service router;

  @action
  goToListPage() {
    this.router.transitionTo('settings.departments.list');
  }
}
